import {
  AfterViewInit,
  ChangeDetectionStrategy, ChangeDetectorRef,
  Component,
  ElementRef,
  Input,
  OnInit,
  ViewChild, ViewRef
} from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { Subject } from 'rxjs/Subject';
import { Store } from '@ngrx/store';
import { take, takeUntil } from 'rxjs/operators';
import { isEmpty, get } from 'lodash';
import { DashboardService } from '../../../../worklist/services/dashboard.service';
import { IgenomicsState } from '@ispm/core/interfaces/genomics-state.interface';
import { diagnosticOrderAllItemsSelector } from '@ispm/test/store/diagnostic-order.selector';
import { TABLELIST_ACTIONS } from '../../../../worklist/interfaces';
import { currentOrderAllData } from '../../store/current-order.selector';
import { TestBarEnableConfirmButtonAction } from '../../store/test-bar.actions';
import { RevisionStatus } from '@ispm/workflow/constants/revisionStatus.enum';
import { WorkflowService } from '@ispm/workflow/services/workflow.service';
import { NavigationEnd, Router } from "@angular/router";
import { testViewPathologistPath, testViewWithPatientProfile } from "@ispm/test/routes/test-view-state-names";
import { RouterManagerService } from "@ispm/core/services/router-manager.service";
import { Subscription } from 'rxjs';

@Component({
  selector: 'gen-test-actions',
  templateUrl: './test-actions.component.html',
  styleUrls: ['./test-actions.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})

export class TestActionsComponent implements OnInit, AfterViewInit {
  @Input() addTestAvailable: boolean = true;
  @Input() previewMode: boolean = false;
  @Input() showTestActions: boolean = true;
  @Input() isCustomConfig: boolean = false;
  @ViewChild('panel', { static: false }) panel: ElementRef;
  @ViewChild('toggle', { static: false }) toggle: ElementRef;

  public panelState: boolean = false;
  public patientTests$: Observable<any[]>;
  public testCount: number = -1;
  public currentRevision: string;
  public hasPatientContext: boolean = false;
  public showActions: boolean = true;
  public patientTestsFromStore = null;

  private destroyer$: Subject<null> = new Subject<null>();
  private WorkflowService: any;
  private allItemsFetchedOnce: boolean = false;
  private readonly destroyCallback: Subscription;

  constructor(
    private route: Router,
    private workflowService: WorkflowService,
    private _dashboardService: DashboardService,
    private _changeDetector: ChangeDetectorRef,
    private readonly store: Store<IgenomicsState>,
    private routerManagerService: RouterManagerService
  ) {
    this.destroyCallback = this.route.events.subscribe(event => {
      if (event instanceof NavigationEnd && !this.allItemsFetchedOnce) {
        // For some unknown reason 'NavigationEnd' is called twice when user selects a test via All Items list. This (non-elegant solution) makes it called only once.
        this.allItemsFetchedOnce = true;
        this.init();

        if (this.panel && this.toggle) {
          this.positionPanel(true);
        }
      }
    });
  }

  ngOnInit() {
    this.init();
   // same fuunction  this._dashboardService.loadAllItems(); is called below
   /* if (!this.previewMode && this.showTestActions) {
      this._dashboardService.loadAllItems();
    }*/
  }

  private async init() {
    if (!this.previewMode && this.showTestActions) {
      let currentOrderDetails;
      this.store.select(currentOrderAllData)
        .pipe(take(1))
        .subscribe(allPatientTests => currentOrderDetails = allPatientTests);

      if (!isEmpty(currentOrderDetails)) {
        const patientTests = get(currentOrderDetails, 'patientAnalysis.allTests', '');
        // If patient has only one test and it is a new test (meaning there cannot be older revisions), no need to fetch patient tests
        if (patientTests.length === 1 && currentOrderDetails.isNewOrder) {
          this.testCount = patientTests.length;
          this.hasPatientContext = !!this.routerManagerService.parameters.patientId;
          this.currentRevision = this.routerManagerService.parameters.revisionId;
          this.patientTestsFromStore = patientTests;
          return;
        }
      }

      await this._dashboardService.loadAllItems();

      this.patientTests$ = this.store.select(diagnosticOrderAllItemsSelector);
      this.patientTests$
        .pipe(
          takeUntil(this.destroyer$.asObservable())
        )
        .subscribe(async tests => {
          const loaded = await JSON.parse(sessionStorage.getItem(TABLELIST_ACTIONS.SET_CONFIG_TEMPLATE)) || {completed: false};
          if (loaded.completed) {
            this.testCount = tests.length;
            this.patientTestsFromStore = tests;
            //since its already there after set timeout
            //this._changeDetector.markForCheck();
            //this._changeDetector.detectChanges();
            setTimeout(() => {
              if (this._changeDetector && !(this._changeDetector as ViewRef).destroyed) {
                this._changeDetector.markForCheck();
                this._changeDetector.detectChanges();
                this.allItemsFetchedOnce = false;
              }
            });

            sessionStorage.removeItem(TABLELIST_ACTIONS.SET_CONFIG_TEMPLATE);
          }
        });
    }

    this.hasPatientContext = !!this.routerManagerService.parameters.patientId;
    this.currentRevision = this.routerManagerService.parameters.revisionId;
  }

  ngAfterViewInit() {
    const route = {
      patientId: this.routerManagerService.parameters.patientId,
      testId: this.routerManagerService.parameters.testId,
      revisionId: this.routerManagerService.parameters.revisionId
    }

    this.workflowService.getPatientAnalyses(route);

    if (this.panel && this.toggle) {
      this.positionPanel(true);
    }
  }


  positionPanel(reAppend: boolean) {
    const panel = this.panel.nativeElement;
    const top = this.toggle.nativeElement.getBoundingClientRect().bottom;
    const right = this.toggle.nativeElement.getBoundingClientRect().right;
    panel.setAttribute('style', `top:${top}px;right: calc(100vw - ${right}px);`);

    if (reAppend) {
      // this.document.body.appendChild(panel);
    }
  }

  goToTest(params) {
    params.patientId = this.routerManagerService.parameters.patientId;

    if (this.isCustomConfig){
      this.route.navigateByUrl(testViewPathologistPath + '/' + params.patientId + '/' + params.testId + '/' + params.revisionId);
    } else{
      this.route.navigate([`${testViewWithPatientProfile}/${params.patientId}/${params.testId}/${params.revisionId}/layoutEngine`],{queryParams: this.routerManagerService.getQueryParams(this.route.url)});
    }

    if (params.status === RevisionStatus.PathwaySelection) {
      this.store.dispatch(new TestBarEnableConfirmButtonAction(false));
    }

    this.togglePanel(null, false);
  }

  togglePanel(event, state: boolean) {
    if (event && (event.target === this.toggle.nativeElement || event.target.parentElement === this.toggle.nativeElement) && state !== undefined) {
      return;
    }

    this.panelState = state !== undefined ? state : !this.panelState;
  }

  ngOnDestroy(): void {
    this._changeDetector.detach();
    this.destroyer$.next();
    this.destroyer$.complete();

    if (this.panel) {
      this.panel.nativeElement.parentNode.removeChild(this.panel.nativeElement);
    }

    if (this.destroyCallback) {
      this.destroyCallback.unsubscribe();
    }
  }

  popupTestCreation($event) {
    this._dashboardService.runConfiguration($event.testConfig, null, $event.patientId);
  }
}
